import { configureStore } from '@reduxjs/toolkit';
import annonceReducer from './AnnonceSlice';     // Tu l'avais déjà
import authReducer from './authSlice';    // On l'ajoute ici

const store = configureStore({
  reducer: {
    annonce: annonceReducer,  // Ton reducer existant
    auth: authReducer,        // Le nouveau reducer pour auth
  },
});

export default store;
